import React, { useContext, useEffect, useState } from "react";

import Footer from "./footer";
import HomeCounters from "./Homecounters";
import { PartenerSheepDeedService } from "../services/parternshipservice";
import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";
import CitySelector from "./User/CitySelectore";
import { ServicesContext } from "../services/ServicesContext";
import { handleRazorpayPayment } from "../services/handlePayment";
import AuthUser from "../services/AuthUser";
import { useNavigate } from "react-router-dom";


function Annualcompliancepvtltd() {

   useEffect(() => {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        setNewData((prevData) => ({
          ...prevData,
          user_name: parsedUser.name || "",
          user_email: parsedUser.email || "",
          user_contact_number: parsedUser.mobile || "",
          user_city: parsedUser.city || "",
        }));
      }
    }, []);


   const [activeQuestion, setActiveQuestion] = useState(null);
     const { http, token } = AuthUser();
   const navigate = useNavigate();
   const toggleQuestion = (questionId) => {
      setActiveQuestion((prev) => (prev === questionId ? null : questionId));
   };

   const [newData, setNewData] = useState({ user_name: '', user_email: '', user_contact_number: '', user_city: '' })

   const [errors, setErrors] = useState({});

      const { services, loading, error } = useContext(ServicesContext);  
      if (loading) {
         return <div>Loading...</div>;  // Show loading state while fetching data
     }
   
     if (error) {
          return <div>{error}</div> // Show error state if there was an issue fetching data
     }
      const service = services.find(s => s.service_id === 8);

   const validateForm = () => {
      const newErrors = {};

      if (!newData.user_name.trim()) {
         newErrors.user_name = 'Name is required.';
      } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
         newErrors.user_name = '*Name should only contain letters and spaces.';
      }


      if (!newData.user_email.trim()) {
         newErrors.user_email = 'Email is required.';
      } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
         newErrors.user_email = 'Enter a valid email address.';
      }

       if (!newData.user_contact_number.trim()) {
         newErrors.user_contact_number = '*number is required.';
       } else if (!/^\d{10}$/.test(newData.user_contact_number)) {
         newErrors.user_contact_number = 'Enter a valid 10-digit contact number.';
       }

      if (!newData.user_city) {
         newErrors.user_city = 'City/District is required.';
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0; // No errors
   };


  

      //  const formPutPartenshipdeed = async (e) => {
      //       e.preventDefault();

      //           // ✅ Check if user is logged in
      //  // if (!token) {
      // //     alert("Please log in to continue.");
      // //    localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
      // //    navigate('/login'); // 👈 Use this if you're using React Router
      // //    return;
      // // }
      //       if (!validateForm()) return;
          
      //         localStorage.setItem("bookingData", JSON.stringify(newData));

      // // Navigate to checkout
      // navigate('/checkout', {
      //    state: {
      //       service: service,

      //    }
      // });
             
      //     };


         const formPutPartenshipdeed = async (e) => {
          e.preventDefault();
      
          if (!validateForm()) return;
      
          try {
              const response = await PartenerSheepDeedService.annualComplainPvtLtdForm(newData);
      
              console.log("API Success:", response);
      
              navigate("/thankyou");
      
              // Optional: reset form
              setNewData(prev => {
  const resetObj = {};
  Object.keys(prev).forEach(key => (resetObj[key] = ""));
  return resetObj;
});
    
      
          } catch (error) {
              console.error("API Error:", error);
              alert("Something went wrong!");
          }
      };

   return (
      <div>

         <div className="hero-area10 header-background">
            <div className="container">
               <div className="row">
                  <div className="col-lg-8">
                     <div className="title title2 ">
                        <div className="headding-shape aniamtion-key-2">
                           <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                        </div>
                        <p className="pdrl-text"><img src="assets/img/image/Line.png" className="line-image" /> <span className="text-color">250k+</span> <span>People trust us</span></p>
                        <h1 className="sk-text-color">Annual Compliance Company
</h1>
                        <p className="pdrl-text">Get Annual Compliance Company
 for only <span className="text-color"> Rs.{service?.price}/- </span> <span>(Final Price, No Hidden Costs)</span></p>
                        <p className="pd-text">Government fees and stamp duties are extra. Please fill out the form to receive a detailed quote in seconds. </p>
                        <p className="pd-text text-center star-text">Within 2 Weeks <span><img className="star" src="assets/image/star.svg" alt="" /></span> Transparent Pricing <span><img className="star" src="assets/image/star.svg" alt="" /></span> No Hidden Fees.</p>
                        <div className="couter-all">
                           <div className="row package-section">
                              <p className="ps-text">Get Absolutely Free In Package</p>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box">
                                    <img src="assets/img/image/pan-tax-registration.svg" />
                                    <p>Complete Documentation</p>
                                 </div>
                              </div>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box">
                                    <img src="assets/img/image/din-and-dsc-for-directors.svg" />
                                    <p>Tax Planning</p>
                                 </div>
                              </div>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box">
                                    <img src="assets/img/image/personal-assistance.svg" />
                                    <p>Personal Assistance</p>
                                 </div>
                              </div>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box">
                                    <img src="assets/img/image/complete-document.svg" />
                                    <p>Planning and Consultation</p>
                                 </div>
                              </div>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box dis">
                                    <img src="assets/img/image/personal-assistance.svg" />
                                    <p>Dedicated Support</p>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
                     <div className="contact3-form-all">
                        <div className="hadding7">
                           <h3>Annual Compliance Company
</h3> <p className="pdrl-text">at Rs.{service?.price}/- Only <br/> <span>(Final Price, No Hidden Costs)</span></p>
                        </div>
                        <form action="#">
                           <div className="form-input-all">
                              <div className="form-input-box">
                                 <div className="row">
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label for="">Name<span className="red">*</span></label>{errors.user_name && <p className="error-text">{errors.user_name}</p>}
                                             <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label for="">Email Address<span className="red">*</span></label>{errors.user_email && <p className="error-text">{errors.user_email}</p>}
                                             <input type="email" placeholder="Enter your Email Address" value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label for="">Contact Number<span className="red">*</span></label>{errors.user_contact_number && <p className="error-text">{errors.user_contact_number}</p>}
                                             <input type="number" placeholder="Enter your Contact Number" value={newData.user_contact_number} onChange={(e) => setNewData({ ...newData, user_contact_number: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-12">
                                    <CitySelector
                                          newData={newData}
                                          setNewData={setNewData}
                                          fieldKey="user_city"
                                          errors={errors}
                                       />
                                    </div>
                                 </div>
                              </div>
                              <div className="space20"></div>
                              <div className="btn-group-2">
                                 <a className="theme-btn-3 btn-color" onClick={formPutPartenshipdeed} href="#">Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                              </div>
                           </div>
                        </form>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space60 bg-white"></div>

         <div className="home4-counters bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-md-12">


                     <HomeCounters />
                  </div>
               </div>


               <div className="space40"></div>
               <div className="row">

                  <div className="col-lg-8">

                     <h2>Annual Compliance Company
 </h2>

                     <p className="pd-text">Are you a Private Limited Company struggling with annual compliance? Dm2Legal has you covered! We offer comprehensive Annual Compliance services tailored for Pvt. Ltd. companies, ensuring you meet all legal and regulatory requirements effortlessly.

                        We take care of every aspect of compliance, including:<br />

                        ✅ Annual General Meeting (AGM) – Assistance in organizing and guiding key decision-making processes. <br />
                        ✅ Registrar of Companies (ROC) Filings – Preparing and submitting financial statements, annual returns, and necessary tax filings. <br />
                        ✅ Tax Compliance – Ensuring adherence to Income Tax, GST, and other relevant regulations. <br/>

                           With Dm2Legal, you can avoid penalties, legal complications, and reputational risks while keeping your company transparent, accountable, and fully compliant.<br />

                           📞 Contact us today for hassle-free compliance!</p>
                  </div>
                  <div className="col-lg-4">
                     <img src="assets/img/images/Annual-Compliance-LLP.png" alt="" />
                  </div>
               </div>


            </div>
         </div>



         <div className="service-binifits9 bg-white" >
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">How to apply</h2>
                        <div className="space20"></div>
                        <img src="assets/img/changedimg/Annual-Compliance-Pvt.-Ltd..png" />
                     </div>
                     <div className="space20"></div>
                  </div>
               </div>
            </div>
         </div>
         <div className="space20 bg-white"></div>

         <div className="last-section bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space20"></div>
                        <h2 className="aos-init aos-animate text-center">Benefits </h2>
                     </div>
                  </div>
               </div>
               <div className="space30"></div>
               <div className="row">
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon1.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Legal Compliance</a></h4>
                           <p className="font-f-7">Meeting annual compliance requirements ensures that your Pvt. Ltd. Company stays in line with India's laws and regulations.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon2.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Avoid Penalties</a></h4>
                           <p className="font-f-7">Fulfilling annual compliance obligations helps you steer clear of penalties and fines that may be imposed for non-compliance.</p>
                        </div>
                     </div>
                  </div>
                  {/* <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon3.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Smooth Operations</a></h4>
                           <p className="font-f-7">Annual compliance promotes transparency and accountability, resulting in smoother operations within the company.</p>
                        </div>
                     </div>
                  </div> */}
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon5.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Shareholder Confidence</a></h4>
                           <p className="font-f-7">Holding Annual General Meetings (AGMs) and filing financial statements helps build shareholder confidence, strengthening their trust in the company.</p>
                        </div>
                     </div>
                  </div>
                  {/* <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon6.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Good Governance</a></h4>
                           <p className="font-f-7">Annual compliance fosters strong governance practices, reflecting your commitment to ethical and transparent business operations.</p>
                        </div>
                     </div>
                  </div> */}
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon6.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Maintaining Reputation</a></h4>
                           <p className="font-f-7">Adhering to legal and regulatory requirements helps preserve your company's reputation and shields it from potential negative consequences.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/work6-icon3.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Access to Funding</a></h4>
                           <p className="font-f-7">Investors and financial institutions often require evidence of annual compliance before offering funding or investment opportunities.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon4.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Better Financial Management</a></h4>
                           <p className="font-f-7">Annual compliance involves preparing financial statements and evaluating the company’s financial health, which aids in improved financial management and informed decision-making.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/brand6-4.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Tax Planning</a></h4>
                           <p className="font-f-7">Adhering to tax regulations facilitates effective tax planning, helping to maximize savings and minimize tax liabilities.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon6.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Stakeholder Communication</a></h4>
                           <p className="font-f-7">The annual compliance process involves engaging with stakeholders, promoting transparency, and maintaining strong relationships with suppliers, customers, and partners.</p>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="space20"></div>
            </div>
         </div>

         <div className="service-binifits9 sp0" id="service2">
            <div className="container orp">
               <div className="row">
                  <div className="col-lg-12 text-center">
                     <div className="hadding7">
                        <div className="space80"></div>
                        <h2>Online Registration Procedure </h2>
                     </div>
                     <div className="partnership-deade-section">
                        <div className="space40"></div>

                        <ul className="disc-list">
                           <li>
                              <h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>Our team will review the documents you’ve submitted, ensuring any inaccuracies or errors are identified and corrected for your peace of mind.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li>
                              <h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>Our top GST experts are here to handle all document requirements and fulfill your registration needs.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li>
                              <h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>We will prepare the necessary documents, forms, and other essential paperwork.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li>
                              <h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>An Annual General Meeting (AGM) must be conducted within six months of the fiscal year-end to discuss and approve financial statements, appoint auditors, and declare dividends.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li>
                              <h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                              <span>We will submit the annual financial statements and return to the Registrar of Companies, ensuring your Pvt. Ltd. Company complies with tax regulations, GST, and other relevant laws.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                        </ul>

                        <div className="space80"></div>
                     </div>
                  </div>
               </div>
            </div>
         </div>



         <div className="bg-white">

            <div className="container">
               <div className="row">
                  <div className="col-12">
                     <div className="faq-items" id="masonry-grid">
                        <div className="mesonry-item general single-price-list">
                           <div className="faqs inner-faq">
                              <h2 className="text-center">FREQUENTLY ASKED QUESTIONS</h2>
                              <div className="space20"></div>
                              <div id="general">


                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 1 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(1)}
                                    >
                                       Q1: When is the deadline to hold an AGM for a Private Limited Company in India?
                                       <span>
                                          {activeQuestion === 1 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 1 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       A Private Limited Company must hold its AGM within 6 months from the end of the financial year, but no later than September 30.                                        </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 2 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(2)}
                                    >
                                       Q2: Which documents must be filed with the ROC for annual compliance?
                                       <span>
                                          {activeQuestion === 2 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 2 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       A Private Limited Company must file MGT-7A (Annual Return) and AOC-4 (Financial Statements) with the Registrar of Companies (ROC) every year.</p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 3 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(3)}
                                    >
                                       Q3: What are the consequences of not holding an AGM on time?
                                       <span>
                                          {activeQuestion === 3 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 3 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Failure to conduct an AGM on time can lead to penalties, with fines up to ₹1 lakh for the company and ₹5,000 per day for officers in default.                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 4 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(4)}
                                    >
                                       Q4: What are the rules for appointing or reappointing auditors in an AGM?
                                       <span>
                                          {activeQuestion === 4 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 4 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">During the AGM, a company must appoint or reappoint auditors for a 5-year term, subject to shareholder approval and compliance with the Companies Act, 2013. </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 5 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(5)}
                                    >
                                       Q5: What happens if a company fails to meet annual compliance requirements?
                                       <span>
                                          {activeQuestion === 5 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 5 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Non-compliance can result in penalties, late fees, director disqualification, and even company strike-off by the Registrar of Companies (ROC).                                        </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 6 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(6)}
                                    >
                                       Q6: What tax compliance obligations do Private Limited Companies have?

                                       <span>
                                          {activeQuestion === 6 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 6 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       A Private Limited Company must file income tax returns (ITR-6), TDS returns, GST returns (if applicable), and comply with tax audit requirements if turnover exceeds the threshold.                                        </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 7 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(7)}
                                    >
                                       Q7: Do Private Limited Companies need to comply with GST regulations?
                                       <span>
                                          {activeQuestion === 7 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 7 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Yes, GST compliance is mandatory if a Private Limited Company has a turnover above ₹40 lakh (₹20 lakh for services) or engages in interstate transactions.                                        </p>
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 8 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(8)}
                                    >
                                       Q8: Can a Private Limited Company outsource its annual compliance?
                                       <span>
                                          {activeQuestion === 8 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 8 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Yes, a Private Limited Company can outsource annual compliance to CA, CS, or legal professionals for ROC filings, tax returns, and audits.                                        </p>
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 9 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(9)}
                                    >
                                       Q9: How does annual compliance support good corporate governance?
                                       <span>
                                          {activeQuestion === 9 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 9 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Annual compliance ensures transparency, legal adherence, financial accuracy, and stakeholder trust, strengthening corporate governance and avoiding penalties.                                       </p>
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 10 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(10)}
                                    >
                                       Q10: Do annual compliance requirements differ by industry or company size?
                                       <span>
                                          {activeQuestion === 10 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 10 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Yes, compliance varies based on industry, turnover, and company size, with additional requirements for listed, regulated, or high-revenue companies.                                       </p>
                                    </div>
                                 </div>








                              </div>

                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space40 bg-white"></div>

         <div className="last-section bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-lg-7 m-auto text-center">
                     <div className="hadding7">
                        <div className="space20"></div>
                        <h2 className="aos-init aos-animate">Why Choose Us?</h2>
                     </div>
                  </div>
               </div>
               <div className="space30"></div>
               <div className="row">
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>1</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/growth.svg" alt="" /></span><a href="single-service-1.html" >Growth & Improvement</a></h4>
                           <p>We are committed to continuous growth and improvement. To us, growth is the fundamental principle of life, and we strive to achieve it. We understand the significance of business growth and its importance to you.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>2</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >Support & Availability</a></h4>
                           <p>We understand how even a small problem or query can cause frustration. That's why we are always available to provide support and resolve any issues you may have, whenever they arise.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>3</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                           <p>Our team consists of experienced professionals who prioritize professionalism and customer satisfaction above all else. Each member is passionate about their respective field and dedicated to delivering the best service.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>4</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/focus.svg" alt="" /></span><a href="single-service-1.html" >Focus</a></h4>
                           <p>We treat every task with the utmost importance. Our team members remain dedicated and focused on addressing even the smallest needs and requirements of our clients.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>5</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/value.svg" alt="" /></span><a href="single-service-1.html" >Value for Money</a></h4>
                           <p>We understand the value of your hard-earned money. That's why we ensure that every penny you invest with us is utilized in the most effective way, delivering the best value for your investment.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>6</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/care.svg" alt="" /></span><a href="single-service-1.html" >Care & Regards</a></h4>
                           <p>We consider you a part of our family, and your challenges and successes are our own. Your interests are our priority, and we are dedicated to fulfilling them with the utmost care and attention.</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space40 bg-white"></div>


         <WhatsAppScrollButton />
         <Footer />
         <CircularScrollProgress />


      </div>

   );
}
export default Annualcompliancepvtltd;